import { render, staticRenderFns } from "./NewGameForm.vue?vue&type=template&id=2bc942c8&"
import script from "./NewGameForm.vue?vue&type=script&lang=js&"
export * from "./NewGameForm.vue?vue&type=script&lang=js&"
import style0 from "./NewGameForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports